/**
 * Type of test gateway information.
 * - Tag: 3094
 * - FIX Specification type: int
 * - Mapped type: number
 * @readonly
 * @public
 */
export const TestGatewayDetailType = Object.freeze({
    MarketDataGatewayIPAddress: 0,
    MarketDataGatewayPortNumber: 1,
    MarketDataGatewayDataFormat: 2,
    MarketDataGatewayFormatVersion: 3,
    MarketDataGatewayRoutingIPAddress: 4,
    OrderEntryGatewayIPAddress: 5,
    OrderEntryGatewayPortNumber: 6,
    OrderEntryGatewaydataFormat: 7,
    OrderEntryGatewayFormatVersion: 8,
    OrderEntryGatewayRoutingIPAddress: 9,
} as const);

export type TestGatewayDetailType = (typeof TestGatewayDetailType)[keyof typeof TestGatewayDetailType];
